export default {
	/**
	 * replaces the child_index string in the pre-generated form fields with the the current time to cause rails to create a new record
	 * f.i. `game[functions_attributes][new_functions][foo]´ becomes `game[functions_attributes][1406818011][foo]´
	 * then inserts the modified fields HTML before the given link
	 * @param {Object} link
	 * @param {String} association name of the model relation
	 * @param {String} content HTML that contains the Rails-conform fields
	 */
	addFields(link, association, content, removeAfterClick) {
		// pp.log("into addFields", link);
		const newFakeId = pp.viewHelpers.generateRandomId();
		const inputNameRegexp = new RegExp("\\[new_" + association + "\\]", "g");
		const inputIdRegexp = new RegExp("_new_" + association + "_", "g");
		const rtfInfoFakeIdRegex = new RegExp(
			'value="new_' + association + '"',
			"g",
		);

		// pp.log("assoc", association);
		// pp.log("input", inputNameRegexp, content.match(inputNameRegexp));
		// pp.log("assoc", inputIdRegexp, content.match(inputIdRegexp));
		// pp.log("assoc", rtfInfoFakeIdRegex, content.match(rtfInfoFakeIdRegex));
		const newFieldsContent = content
			.replace(inputNameRegexp, "[" + newFakeId + "]")
			.replace(inputIdRegexp, "_" + newFakeId + "_")
			.replace(rtfInfoFakeIdRegex, 'value="' + newFakeId + '"');
		const $newFieldsContent = $(newFieldsContent);
		// Increment the sort order number
		pp.backend.formHelpers.incrementNewFieldsSortOrder(
			$(link),
			$newFieldsContent,
		);
		$(link).before($newFieldsContent);

		pp.backend.formHelpers.showOrRemoveRtfInfosAddButtonFor(
			// @ts-expect-error
			$(link).closest(".Form__nested-fields-set"),
			removeAfterClick,
		);

		pp.backend.formHelpers.initSelect2For(
			$(link).prev().find("select:visible"),
		);
		pp.backend.formHelpers.convertFormHintsToPopovers();

		const $mirrorableInputs = $newFieldsContent.find(
			"input[data-mirror-to-selector]",
		);
		pp.backend.formHelpers.initMirrorInputs($mirrorableInputs);
		pp.viewHelpers.dependentInputs.init($newFieldsContent);

		// @ts-expect-error
		$(link).prev().find("a.popover-action").popover(); // Manually initialize popovers for the new content

		// Find the first input field and set the focus on it
		const $firstInputInField = $newFieldsContent
			.find("select, input:visible")
			.first();
		if ($firstInputInField.length) {
			const timeout = $firstInputInField.hasClass("select2-hidden-accessible")
				? 100
				: 0;
			setTimeout(() => {
				if (!$firstInputInField.hasClass("select2-hidden-accessible")) {
					return; // Might still not be initiliazed for select2, e.g. for AuthTable select fields
				}
				// @ts-expect-error
				$firstInputInField.select2("open");
			}, timeout);
		}
	},

	// Assumes sort order field is called number and Modifies jquery $newFieldsContent obj
	incrementNewFieldsSortOrder($link, $newFieldsContent) {
		let sortOrderInputName = $newFieldsContent.attr(
			"data-sort-order-target-field",
		);
		if (sortOrderInputName !== undefined) {
			var isNestedNumberInput = false;
		} else {
			// Try to find sort order input in a nested field
			sortOrderInputName = $newFieldsContent
				.find("[data-sort-order-target-field]")
				.first()
				.attr("data-sort-order-target-field");
			if (sortOrderInputName !== undefined) {
				var isNestedNumberInput = true;
			} else {
				// Still undefined, nothing we can do here
				return;
			}
		}
		const $sortOrderInput = $newFieldsContent.find(
			`input[name$='[${sortOrderInputName}]']`,
		);

		let $prevField;
		let prevSortOrder = 0;
		// If the field with the number input is nested in some other (parent) element, get the immediate predecessor of
		// the parent by using the class of the parent that was just inserted, and then find the nested preceeding number field inside that element
		if (isNestedNumberInput) {
			const classOfInsertedField = $newFieldsContent.attr("class");
			$prevField = $link
				.prevAll(`.${classOfInsertedField}`)
				.first()
				.find("[data-sort-order-target-field]");
		} else {
			$prevField = $link.prevAll("[data-sort-order-target-field]").first(); // The immediate predecessor comest first
		}
		if ($prevField.length) {
			prevSortOrder = $prevField
				.find(`input[name$='[${sortOrderInputName}]']`)
				.val();
		}
		// pp.log($link, $prevField, $sortOrderInput, prevSortOrder);
		// @ts-expect-error
		const sortOrder = parseInt(prevSortOrder) + 1;
		$sortOrderInput.val(sortOrder);
	},

	removeAddFieldsButton($wrappingEl) {
		if ($wrappingEl.length == 0) {
			console.error(
				"Check the rtfInfo has been wrapped with a div.Form__nested-fields-set",
			);
		}
		// pp.log("Removing Add fields Button", $wrappingEl.find('.j-add-fields-button'));
		$wrappingEl.find(".j-add-fields-button").remove();
	},

	/**
	 * Check if a wrapper element containing a collection of .Form__nested-fields-set__set-with-locale and a button should remove the button based on
	 * the editing_language / gender and the existing .Form__nested-fields-set__set-with-locale els.
	 * @param {array} $rtfBlocks
	 * @param {boolean} forceRemoval
	 */
	showOrRemoveRtfInfosAddButtonFor($rtfBlocks, forceRemoval) {
		// @ts-expect-error
		$rtfBlocks.each((idx, rtfInfosWrapper) => {
			const $wrapper = $(rtfInfosWrapper);
			var rtfOptionsHash = $wrapper.attr("data-rtf-display-conditions");
			if (!rtfOptionsHash) {
				return;
			}
			// @ts-expect-error
			var rtfOptionsHash = JSON.parse(rtfOptionsHash);

			if (forceRemoval) {
				if ($rtfBlocks.length > 1) {
					console.error(
						"Are you sure you want to force removal on multiple rtf blocks",
					);
				}
				pp.backend.formHelpers.removeAddFieldsButton($wrapper);
				return;
			}

			const $rtfChildren = $wrapper.find(
				".Form__nested-fields-set__set-with-locale",
			);
			const currentEditingLocale = $("body").attr(
				"data-backend-editing-locale",
			);
			const $rtfOfCurrentEditingLocale = $rtfChildren.filter(
				(idx, child) => $(child).data("locale") == currentEditingLocale,
			);

			// TODO account for genders in RtfInfo fields that belong to Unlockables
			if (
				// @ts-expect-error
				!rtfOptionsHash.force_genders &&
				// @ts-expect-error
				rtfOptionsHash.max_children_per_locale ==
					$rtfOfCurrentEditingLocale.length
			) {
				pp.backend.formHelpers.removeAddFieldsButton($wrapper);
			}
		});
	},

	/**
	 * Hides the record fields that contain the given link and sets the `_destroy´ attribute of the fields to true, causing Rails to delete the record
	 * only works with the functions in CmsfieldsHelper
	 * @param {Object} link
	 */
	removeFields(link) {
		pp.log("BACKEND removeFields -- link:", link);

		$.confirm({
			text: I18n.t("global.are_you_sure"),
			confirm() {
				const $closestKvPairFields = $(link).closest(
					".Form__hash-field__kv-pair",
				);
				// For nested key value pairs that don't point to a DB record (i.e. where the fields don't have a hidden input for `id`)
				if (
					$closestKvPairFields.length &&
					!$closestKvPairFields.find("input[type=hidden][name$='[id]']").length
				) {
					$(link).closest(".Form__hash-field__kv-pair").remove();
				} else {
					const $deleteMarker = $(link).prev("input[type=hidden]");
					if (!$deleteMarker.length) {
						console.error(
							"Count not find toggle input to mark field as to destroy.",
						);
					}
					$deleteMarker.val("true").trigger("change");
					$(link)
						.closest(
							"div.fields, div.Form__nested-fields-set__set-with-locale, div.Form__nested-fields-set, div.Form__nested-fields-set__set, .Form__hash-field__kv-pair",
						)
						.hide();
				}
			},
		});
	},

	authTables: {
		initialLoadQueued: false,
		loadRecordsDynamically(modelArrayPath, translatedModelToControllerMap) {
			// pp.log("click listener init", modelArrayPath, translatedModelToControllerMap);
			if (modelArrayPath === undefined) {
				return;
			}

			/**
			 * listen for clicks on an optgroup in a select field and get the routes of this optgroup.
			 * then insert routes under the optgroup. unbind other event listeners first to make
			 * sure that the request is only being sent once
			 */
			$("select.j-auth-tables-select > optgroup")
				.off("click")
				.on("click", (event) => {
					event.stopPropagation();
					// pp.log("BACKEND auth-tables optgroup click -- target, children length:", $(event.currentTarget), $(event.currentTarget).children().length);
					if ($(event.currentTarget).children().length) {
						return; // don't do anything if the data has already been inserted
					}
					const whiteListSelected = $(event.currentTarget)
						.closest(".Module__content")
						.find("input[name*='is_black_list'][value='false']")
						.prop("checked");
					const $parentSelect = $(event.target).parent();
					// @ts-expect-error
					const selectedEntries = $parentSelect
						.attr("data-selected-entries")
						.split(",");
					$.ajax({
						url: modelArrayPath,
						dataType: "json",
						data: {
							action_controller:
								// @ts-expect-error
								translatedModelToControllerMap[event.currentTarget.label],
							which_list: whiteListSelected ? "white" : "black",
						},
					}).done((data) => {
						if (data === null) {
							pp.notifications.display("notice", "Nothing found", {
								dismissable: true,
							});
							return;
						}
						let appendString = "";
						data[1].forEach((selectOptionData) => {
							const option = selectOptionData[0];
							const label = selectOptionData[1];
							const optionIsSelected = selectedEntries.indexOf(option) != -1;

							// This should only ever be the case in the extra "Navigation" optgroup, where
							// the select options are prerendered via AuthTable.collect_fields_data
							if ($(`option[value="${option}"]`).length) {
								$(`option[value="${option}"]`).prop(
									"selected",
									optionIsSelected,
								);
							} else {
								// Otherwise append new option
								// NB String interpolation does not work here, apparently because the `option` has curly brackets
								appendString +=
									'<option value="' +
									option +
									(optionIsSelected ? '" selected="selected"' : '"') +
									">" +
									label +
									"</option>";
							}
						});
						event.target.innerHTML = appendString;
						const select2WasOpen = $parentSelect.data("select2").isOpen();
						pp.backend.formHelpers.initSelect2For($parentSelect);
						if (select2WasOpen) {
							// @ts-expect-error
							$parentSelect.select2("open");
						}
					});
				});
		},

		initInitialLoadOfPresentControllerActions(translatedModelToControllerMap) {
			if (pp.backend.formHelpers.authTables.initialLoadQueued) {
				return;
			}
			pp.backend.formHelpers.authTables.initialLoadQueued = true;
			setTimeout(() => {
				$(
					"select.j-auth-tables-select[data-controllers-with-present-actions]",
				).each(function () {
					const $select = $(this);
					// @ts-expect-error
					const controllers = $select
						.attr("data-controllers-with-present-actions")
						.split(",");
					controllers.forEach((presentController) => {
						const translatedEntry = Object.entries(
							translatedModelToControllerMap,
						).find(([translatedLabel, controller]) => {
							return controller == presentController;
						});
						$select
							// @ts-expect-error
							.find(`optgroup[label='${translatedEntry[0]}']`)
							.trigger("click");
					});
					$(this).removeAttr("data-controllers-with-present-actions");
				});
				pp.backend.formHelpers.authTables.initialLoadQueued = false;
			}, 500);
		},
	},

	/**
	 * Create and observe the select fields for each game template's actor configuration for a specific game size
	 */
	actorTplsConfiguration: {
		init() {
			pp.log("into actorTplsConfiguration.init");
			let presentSizes = [];
			const $newConfigSizeInput = $("#configuration_size");
			$("input.j-membership-conf-field").each(function () {
				// @ts-expect-error
				const thisActorsSizes = eval(this.value);
				for (const i in thisActorsSizes) {
					if (presentSizes.indexOf(thisActorsSizes[i]) == -1) {
						presentSizes.push(thisActorsSizes[i]);
					}
				}
			});
			presentSizes = presentSizes.sort((a, b) => a - b);
			// pp.log("presentSizes", presentSizes);

			for (const i in presentSizes) {
				// Set here so that the correct size is given when JS snippet in the HTML calls `createdNewSet`
				$newConfigSizeInput.val(presentSizes[i]);
				$(".j-add-new-set-button").trigger("click");
			}

			const newConfigSize =
				presentSizes.length == 0 ? 4 : _.last(presentSizes) + 1;
			$newConfigSizeInput.val(newConfigSize);

			$("form[id^=edit_game]").on("submit", (event) => {
				// Iterate over all configuration sets and check if the promised size is matched
				$("div.j-configuration-field").each(function () {
					// @ts-expect-error
					if ($(this).find("select").val().length != $(this).data("for-size")) {
						// pp.log("value mismatch", this, event, $(`input[form='${event.target.id}']`))
						$(this)
							.find("span.select2-container")
							// @ts-expect-error
							.popover({
								content: "does not have the right number of Actors selected",
								placement: "bottom",
								trigger: "manual",
							})
							.popover("show");
						event.preventDefault();

						// Listen for change in in selection and remove popover
						$(this)
							.find("select")
							.one("select2:close", function () {
								// @ts-expect-error
								$(this).siblings("span.select2-container").popover("destroy");
							});
						setTimeout(() => {
							$(`input[form='${event.target.id}']`).removeAttr("disabled"); // Re-enable the submit button
						}, 150);
						return;
					}
				});
			});
		},

		createdNewSet($insertedFields) {
			pp.log("actorTplsConfiguration into createdNewSet", $insertedFields);
			$("#j-placeholder").remove();
			// @ts-expect-error
			const size = parseInt($("#configuration_size").val(), 10);
			const cloneFromPrevious = $("#clone_from_next_biggest_set").prop(
				"checked",
			);
			// pp.log("createdNewSet", $insertedFields, size, cloneFromPrevious);

			if ($(`.j-configuration-field[data-for-size='${size}']`).length) {
				pp.notifications.display(
					"error",
					"Field for that configuration size already exists!",
				);
				$insertedFields.remove();
				return;
			} else {
				$insertedFields.attr("data-for-size", size);
			}

			const $thisSelect = $insertedFields.find("select");
			$insertedFields.find("span.j-size-indicator").html(size);

			let foundPresentConf = false;
			if (cloneFromPrevious) {
				const presentSizes = [];
				$(".j-configuration-field").each(function () {
					if ($(this).data("for-size") < size) {
						presentSizes.push($(this).data("for-size"));
					}
				});
				const nextBiggestSize = _.max(presentSizes);

				$("input.j-membership-conf-field").each(function () {
					// @ts-expect-error
					const sizes = eval(this.value);
					if (sizes.indexOf(nextBiggestSize) != -1) {
						$thisSelect
							.children(`option[value='${$(this).data("for-actor")}']`)
							.prop("selected", true);
					}
				});

				if (nextBiggestSize == undefined) {
					pp.notifications.display(
						"error",
						"No set to clone from, an empty set was created",
					);
				}
			} else {
				// Always look for already present hidden fields from the DB
				let foundPresentConf = false;
				$("input.j-membership-conf-field").each(function () {
					// @ts-expect-error
					const sizes = eval(this.value);
					// pp.log(sizes, $(this).data('for-actor'));
					if (sizes.indexOf(size) != -1) {
						$thisSelect
							.children(`option[value='${$(this).data("for-actor")}']`)
							.prop("selected", true);
						foundPresentConf = true;
					}
				});
				if (foundPresentConf) {
					$thisSelect.one("select2:open", () => {
						$thisSelect.select2("close"); // Close the select menu that was opened in `addFields`
					});
				}
			}

			// Means that the field was added manually by the user
			if (!foundPresentConf) {
				$("#configuration_size").val(size + 1);
			}
			$insertedFields
				.find("input[name*='_destroy']")
				.on(
					"change",
					pp.backend.formHelpers.actorTplsConfiguration.removeSelectOption,
				);

			$thisSelect.on(
				"change",
				pp.backend.formHelpers.actorTplsConfiguration.updateHiddenConfField,
			);
			$thisSelect.trigger("change");
		},

		updateHiddenConfField() {
			const thisSizeAttr = $(this)
				.closest(".Form__nested-fields-set__set")
				.data("for-size"); // might be null
			const thisActorIds = $(this).val() || [];

			// pp.log("updateHiddenConfField", thisSizeAttr, thisActorIds);

			$("input.j-membership-conf-field").each(function () {
				// @ts-expect-error
				const sizes = eval(this.value);
				if (
					// @ts-expect-error
					thisActorIds.indexOf($(this).attr("data-for-actor")) != -1 &&
					sizes.indexOf(thisSizeAttr) == -1
				) {
					// pp.log("pushing", thisSizeAttr, "to", this);
					sizes.push(thisSizeAttr);
					$(this).val("[" + sizes + "]"); // No string interpolation here!
				} else if (
					sizes.indexOf(thisSizeAttr) != -1 &&
					// @ts-expect-error
					thisActorIds.indexOf($(this).attr("data-for-actor")) == -1
				) {
					// pp.log("removing", thisSizeAttr, "from", this);
					sizes.splice(sizes.indexOf(thisSizeAttr), 1);
					$(this).val("[" + sizes + "]"); // No string interpolation here!
				}
			});
		},

		removeSelectOption() {
			const $optionFields = $(this).closest("div.j-configuration-field");
			$optionFields.find("select").val("").trigger("change"); // set empty and trigger `updateHiddenConfField`
			$optionFields.remove();
		},
	},

	/**
	 * Trigger select2 for all select elements that have a size attribute and are not already initialized
	 */
	initSelect2For($elems, opts = {}) {
		// pp.log("backend initSelect2For -- $elems:", $elems);
		$elems.each((index, elem) => {
			// pp.log("BACKEND formhelpers initSelect2For -- index, elem, options:", index, elem, opts);
			const $elem = $(elem);
			const computedOptions = {
				minimumResultsForSearch: $elem.data("tag") ? undefined : 15,
				tags: $elem.data("tag") !== undefined,
				escapeMarkup(itemText) {
					return itemText;
				},
			};

			const options = Object.assign(computedOptions, opts);
			// @ts-expect-error
			$elem.select2(options);
			// Open the select dropdown when the rendered select2 element gets focus.
			// Only for non-multiselect boxes - in multiselect boxes the user can start typing
			if (!$elem.data("select2").options.options.multiple) {
				$elem.data("select2").$selection.on("focus", () => {
					// @ts-expect-error
					$elem.select2("open");
				});
			}
			// Prevent the select (not select2) option from being selected if a link has been clicked inside of the rendered select2 option
			// @ts-expect-error
			$elem.on("select2:selecting", ({ params }) => {
				if (
					params.args.originalEvent &&
					($(params.args.originalEvent.target).closest(
						".j-prevent-event-bubble-up",
					).length ||
						params.args.originalEvent.target.classList[0] == "glyphicon")
				) {
					return false;
				}
			});
			// Listen for click events on the fake `optgroup` elements (if any) and forward that click event
			// to the resp. real `optgroup` element in the hidden `select`.
			// This is then used by `pp.backend.formHelpers.authTables.loadRecordsDynamically`
			$elem.on("select2:open", () => {
				setTimeout(() => {
					$(".select2-results")
						.find("li.select2-results__option[role='group']")
						.off("click")
						.one("click", function () {
							$elem
								.find(`optgroup[label='${$(this).attr("aria-label")}']`)
								.trigger("click");
						});
				}, 50);
			});
			// Show the "tag" (i.e. the content from the ArticleTemplateGapOption) as the placeholder in the searchbox
			if ($elem.data("tag") !== undefined) {
				$elem.on("select2:open", (event) => {
					$(".select2-search__field").attr("placeholder", $elem.data("tag"));
				});
			}

			// no need to hack the width for multiselect boxes
			if ($elem.data("select2").options.options.multiple) {
				return; // `continue` for jQuery
			}

			// store the calculated width and then set it to 0, so that the container won't be expanded due to too wide boxes
			// in the next loop the calculated width will be restored, or reset so that the element will fit into the container
			const $renderedSelect = $elem.data("select2").$container;
			$renderedSelect.data("calculatedWidth", $renderedSelect.outerWidth());

			pp.backend.formHelpers.fixSelect2WithforElem(elem);
		});
	},

	fixSelect2WithforElem(elem) {
		if (
			elem.size < 15 &&
			elem.childNodes.length < 15 &&
			!$(elem.childNodes).last().is("optgroup")
		) {
			return; // `continue` for jQuery
		}
		const $thisSelectElem = $(elem);
		const $renderedSelect = $thisSelectElem.data("select2").$container;
		const calculatedWidth = $renderedSelect.data("calculatedWidth");
		const parentWidth = $renderedSelect.parent().width();

		if (calculatedWidth === undefined) return; // continue for jQuery

		// 48px is an approximation for the extra width from padding that select2 needs
		if (calculatedWidth + 48 < parentWidth) {
			$renderedSelect.outerWidth(calculatedWidth + 48);
		}
	},

	/**
	 * Initializes the bootstrap-datetimepicker for the respective fields
	 * also adds a listener to write the (converted for rails) date into the hidden field
	 * that was created by the datetimepicker_fields helper
	 */
	initDateTimePicker(includeAllElements = false) {
		const selector = includeAllElements
			? "div.datetimepicker"
			: "div.datetimepicker:not(.j-manual-datetime-init-date)";
		$(selector).each(function () {
			let minDate;
			let maxDate;
			const $this = $(this);
			// pp.log("at el for datetimepicker", $this);
			const $hiddenInput = $this.prev("input.j-datetimepicker-hidden");
			const $visibleInput = $this.find("input");
			// @ts-expect-error
			const date = moment($hiddenInput.val());
			$this.on("dp.change", (event) => {
				// pp.log("change event", event);
				// @ts-expect-error
				if (event.date && event.date._isValid) {
					if (
						// @ts-expect-error
						$visibleInput[0].form &&
						// @ts-expect-error
						$visibleInput[0].form.ClientSideValidations
					) {
						// @ts-expect-error
						$visibleInput[0].form.ClientSideValidations.removeError(
							$visibleInput,
						);
						$visibleInput.trigger(
							"element:validate:pass.ClientSideValidations",
						);
					} else {
						console.warn(
							"initDateTimePicker: did not find ClientSideValidations for form of",
							$visibleInput,
						);
					}
					if (!$hiddenInput.prop("disabled")) {
						setTimeout(function () {
							// Let other code run first
							// @ts-expect-error
							$hiddenInput.val(event.date.format()).trigger("change"); // ISO8601 -- trigger other listeners (in game-cloning.js)
						}, 50);
					}
				} else {
					// This will show the popover but not actually mark the element as invalid or disable the form
					setTimeout(function () {
						if (
							// @ts-expect-error
							$visibleInput[0].form &&
							// @ts-expect-error
							$visibleInput[0].form.ClientSideValidations
						) {
							// @ts-expect-error
							$visibleInput[0].form.ClientSideValidations.addError(
								$visibleInput,
								I18n.t("activemodel.errors.messages.inclusion"),
							);
							$visibleInput.trigger(
								"element:validate:fail.ClientSideValidations",
							);
						} else {
							console.warn(
								"initDateTimePicker: did not find ClientSideValidations for form of",
								$visibleInput,
							);
						}
					}, 10);
					$hiddenInput.val("");
				}
			});

			// Enable past dates if it is explicitly allowed or of there is a date set in the hidden input which is already in the past
			// the `datetimepicker_fields` will make sure that that's allowed
			if (
				$hiddenInput.data("allowPast") == true ||
				(date !== undefined && date.isBefore(Date.now()))
			) {
				minDate = undefined;
			} else {
				// @ts-expect-error
				minDate = new Date(new Date() - (new Date() % 60000) + 60000); // begining of the next minute
			}
			maxDate = $hiddenInput.data("maxDate")
				? // @ts-expect-error
					moment($hiddenInput.data("maxDate"))
				: undefined;

			const options = {
				locale: I18n.locale,
				minDate, // Only set minDate if the already present date is not in the past
				maxDate,
			};
			if ($hiddenInput.data("onlyShowDate")) {
				// @ts-expect-error
				options.format = moment.localeData()._config.longDateFormat.L;
			} else {
				options.sideBySide = true;
			}
			// @ts-expect-error
			$this.datetimepicker(options);

			$this.data("DateTimePicker").date(date);
		});
	},

	convertFormHintsToPopovers() {
		// The data attributes reflect those from `popover_helper` (except `placement`)
		$("a.form-hint:not(:empty)").each(function () {
			if ($(this).data("bs.popover")) {
				// @ts-expect-error
				$(this).popover("destroy");
			}
			// @ts-expect-error
			$(this).popover({
				content: $(this).html(),
				trigger: "hover",
				html: true,
				animation: false,
				placement: "top",
				container: "body",
			});
			$(this).html("");
		});
	},

	// NB only works when called from with `deep_nested_hash_fields_helper`from cms_fields_helper.rb
	stringifyDeepNestedHashFields(attribute) {
		const $hiddenInput = $(`.j-${attribute}-target`);

		// Always rebuild the whole hash from scratch, raher than trying to merge in the entry from the one element that was edited.
		// (The latter would require filtering out deeply nested *empty* entries and their containing empty parents when the text an input was erased.)
		$(`[name^='${attribute}']`).on("input keyup", () => {
			const hash = {};
			$("[name^='custom_wording']")
				.filter(function () {
					// @ts-expect-error
					return this.value !== "";
				})
				.each(function () {
					// @ts-expect-error
					const inputName = $(this).attr("name").replace(attribute, "");

					// Chop up the "fake" form attribute (from `fake_form_attribute` in cms_fields_helper.rb) to generate the nesting path for the hash
					const keyNesting = inputName
						.substr(1, inputName.length - 2)
						.split("][");

					let workingHash = {};
					workingHash[keyNesting.pop()] = $(this).val();
					keyNesting.reverse().forEach((key) => {
						const wrappedHash = {};
						wrappedHash[key] = workingHash;
						workingHash = wrappedHash;
					});
					_.merge(hash, workingHash);
				});
			$hiddenInput.val(JSON.stringify(hash));
		});
		$(`[name^='${attribute}']`).first().trigger("keyup"); // Build hash once now
	},

	//Mirrors one input's values to another based on a condition
	initMirrorInputs($els) {
		$els.on("change keyup", function (e) {
			// @ts-expect-error
			const $el = $(this);
			const $target = $el
				// @ts-expect-error
				.closest($el.attr("data-mirror-to-parent"))
				// @ts-expect-error
				.find($el.attr("data-mirror-to-selector"));
			const elVal = parseFloat($el.val());
			// @ts-expect-error
			const targetVal = parseFloat($target.val());
			switch ($el.attr("data-mirror-when")) {
				case "!=":
					if (elVal != targetVal) {
						$target.val(elVal);
					}
					break;
				case "<":
					if (elVal < targetVal) {
						$target.val(elVal);
					}
					break;
				case ">":
					if (elVal > targetVal) {
						$target.val(elVal);
					}
					break;
				default:
					console.error("unsupported operator");
					break;
			}
		});
	},

	initAttachmentFields() {
		$(".AttachmentFields__AttachmentWrapper input").on(
			"change input",
			function (event) {
				// Reset to false in case user has previously marked the attachment to be destroyed
				$(this)
					.closest(".AttachmentFields")
					.find("input[type='checkbox'][name*='_destroy']")
					.prop("checked", false);
				$(this)
					.closest(".AttachmentFields")
					.find(".Form__attachment-remove-button-wrapper__checkmark")
					.remove();
				// Can't show a preview of the to-be-uplaoded file easily, so just remove the URL to the old file.
				$(this)
					.closest(".AttachmentFields")
					.find(".ImagePreview__image, .Avatar__image")
					.removeAttr("style");
				$(this)
					.closest(".AttachmentFields")
					.find(".ImagePreview__filename")
					.addClass("hidden");
			},
		);
	},

	initDynamicActorPropertyLinkConnectionFields($selectInput) {
		$selectInput.on("change", (event) => {
			pp.log($selectInput.find(":selected").data("calculationParams"));
			var $connectionNameInput = $selectInput
				.parent()
				.siblings(".Form__hash-field__kv-pair__small-input")
				.find("select");
			var oldConnectionName = $connectionNameInput.val();
			$connectionNameInput.children().remove();
			$selectInput
				.find(":selected")
				.data("calculationParams")
				.forEach(function (availableConnection) {
					$connectionNameInput.append(
						`<option value='${availableConnection}'>${availableConnection}</option>`,
					);
				});
			$connectionNameInput.val(oldConnectionName).trigger("change");
		});
	},
};
